const initialState = {}; // for pre-init
export const stateLoader = () => ({
  ...initialState,
  catalog: {
    academicYears: [],
    months: [],
    centers: [],
    providers: [],
    status: [],
    billingServiceTypes: [],
    billingDisciplines: [],
    billingSpecialists: [],
    serviceTypes: [],
    interventors: [],
  },
  filter: {
    academicYear: null,
    month: null,
    center: null,
    status: null,
    invoice: null,
  },
  billingSearchResults: {
    data: [],
    pagination: {
      currentPage: 0,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
    },
    paginationConfig: {
      initialCurrentPage: 1,
      initialPageSize: 15,
    },
  },
  billingServiceFilter: {
    serviceType: null,
    discipline: null,
    specialist: null,
    alert: null,
    sie: '',
  },
  billingServiceDetails: {
    data: [],
    pagination: {
      currentPage: 0,
      pageCount: 15,
      totalItemCount: 0,
    },
  },
  visitDetails: {
    data: [],
    pagination: {
      currentPage: 0,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
    },
  },
  billingStatusList: [],
  minYearId: 20,
  billingTracking: [],
  billingAdjustmentDetailList: {
    data: [],
    pagination: {
      currentPage: 0,
      pageCount: 15,
      totalItemCount: 0,
    },
  },
  adjustmentDetails: {
    reasons: [],
    visits: [],
  },
});

export default stateLoader();
